enum Raid {
  MoltenCore,
  BlackwingLair,
  ZulGurub,
  TempleOfAhnQiraj,
  RuinsOfAhnQiraj,
  Naxxramas
}

export default Raid
